<template>
	<Modal
		:title="title"
		size="lg"
	>
		<VueMarkdown
			class="rules"
			:source="rules[version]"
		/>
		<template v-slot:footer>
			<button
				class="btn btn-light"
				@click="$emit('closed')"
			>Back</button>
		</template>
	</Modal>
</template>

<script>
export default {
	props: ["version"],
	data() {
		return {
			rules: {},
			versions: {}
		};
	},
	computed: {
		title() {
			const v = this.versions[this.version];
			return "Game rules" + (v ? " - " + v : "");
		}
	},
	async created() {
		let r = await fetch("settings.json");
		const settings = await r.json();
		settings.versions.forEach(async v => {
			this.versions[v.value] = v.text;
			let r = await fetch(`rules-${v.value}.md`);
			this.rules[v.value] = await r.text();
		});
	}
};
</script>

<style lang="scss">
.rules {
	h3 {
		font-weight: bold;
		margin: 3rem 0 1.5rem;

		&:first-child {
			margin-top: 0;
		}
	}

	img {
		display: block;
		margin: 2rem auto 0.5rem;
	}

	p img {
		max-width: 50%;
	}

	.conflict td img {
		max-width: 75%;
	}

	img + em,
	.conflict + p em {
		display: block;
		font-size: 85%;
		margin-bottom: 2rem;
		text-align: center;
	}
}
</style>